//**
// @category Hammer
// @copyright Copyright (c) Weidenhammer Systems Corporation
//**
// =============================================================================
// Promoted Products
// =============================================================================

//**
// Import statement is not supported in Shopify's JavaScript files, as they are not processed by a module loader.
// Instead, you can define your code inside an IIFE (Immediately Invoked Function Expression) to create a local scope and avoid polluting the global namespace.
// Or in this case according to general architecture concept add to the window.theme
//**

window.theme = window.theme || {};

(function() {
    class ProductManager {
        #storefrontAccessToken;

        constructor() {
            this.#storefrontAccessToken = '87be32c87487a62e0a1abbc5fa8442e6';
            this.domain = storeDomain;

            this.CartManager = new theme.CartManager();

            this.productsData = [];
            this.products = {};

            this.lang = {
                addCart: 'Add to Cart',
            }
        }

        // Method to initialize all products on the page
        async initProducts($products) {
            this.#saveProductToState($products)
            const productsRawData = await this.#fetchProducts(Object.keys(this.products));
            this.#dataPreparation(productsRawData);
            this.#createProductHTML(this.productsData);
            this.#attachEventListeners(Object.entries(this.products));

            return Object.values(this.products);
        }

        // Saving DOM elements to the state with id as a keys
        #saveProductToState($products) {
            Array.from($products).map($product => this.products[parseInt($($product).data('id'), 10)] = $($product));
        }

        // Method to fetch the product data by its SKU
        async #fetchProducts(idsArray) {
            const query = `query test($ids: [ID!]!) {
              nodes(ids: $ids) {
                ... on Product {
                  id
                  title
                  handle
                  totalInventory
                  onlineStoreUrl
                  images(first: 1) {
                    nodes {
                      altText
                      url(transform: {maxHeight: 120, maxWidth: 120})
                    }
                  }
                  variants(first: 20) {
                    edges {
                      node {
                        id
                        sku
                        title
                        availableForSale
                        price
                      }
                    }
                  }
                }
              }
            }
            `;

            const variables = {
                ids: idsArray.map(id => `gid://shopify/Product/${id}`),
            };

            const response = await fetch(`https://${this.domain}/api/graphql.json`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Shopify-Storefront-Access-Token': this.#storefrontAccessToken,
                },
                body: JSON.stringify({ query, variables }),
            });

            const { data, errors } = await response.json();
            if (errors) throw new Error(errors[0].message);

            return data;
        }

        // Method to prepare data from graphQL view to simple obj
        #dataPreparation(productsData) {
            this.productsData = productsData.nodes.map((product) => {
                const variantNode = product.variants?.edges[0]?.node;
                const variantTitle = variantNode.title !== "Default Title" ? variantNode.title : '';

                return {
                    id: product.id.match(/\d+$/)[0],
                    handle: product.handle,
                    title: product.title + variantTitle,
                    totalInventory: product.totalInventory,
                    url: product.onlineStoreUrl,
                    image: product.images?.nodes[0]?.url,
                    variantId: variantNode.id.match(/\d+$/)[0],
                    price: variantNode.price,
                    sku: variantNode.sku,
                    variantAvailableForSale: variantNode.availableForSale,
                }
            })
        }
    
        // Method to create the HTML structure for a product
        #createProductHTML(products) {
            products.map(product => {
                const $product = this.products[product.id];

                const productHTML = `
                    <a class="accessoryCard__link" href="${product.url}" title="${product.title}">
                        <div class="accessoryCard__image">
                            <img src="${product.image}" alt="${product.title}">
                        </div>
                        <div class="accessoryCard__content">
                            <h2 class="accessoryCard__title">${product.title}</h2>
                            <div class="accessoryCard__interactions">
                                <div class="accessoryCard__sku">Model: ${product.sku}</div>
                                <div class="accessoryCard__price">$${product.price}</div>
                                ${product.variantAvailableForSale ? "" : "<p class='accessoryCard__stock'>Out of Stock</p>"}
                                <button class="accessoryCard__addToCart" ${product.variantAvailableForSale ? "" : 'disabled'}>${this.lang.addCart}</button>
                            </div>
                        </div>
                    </a>
                `;

                $product.data('variantId', product.variantId);
                $product.append(productHTML);
            })
        }

        // Method to attach event listeners to the product elements
        #attachEventListeners(products) {
            products.map(([id, $product]) => {
                const $addToCart = $('.accessoryCard__addToCart', $product);
                const variantId = $($product).data('variantId');

                $addToCart.on('click', async (e) => {
                    e.preventDefault();
                    const target = $(e.currentTarget)
                    const $cardLink = target.closest('.accessoryCard__link');

                    $cardLink.addClass('loading');
                    target.text('Adding to Cart...')

                    await this.#addToCart(variantId);

                    $cardLink.removeClass('loading');
                    target.text(this.lang.addCart)
                });
            });
        }

        // Function to add a product to the cart
        async #addToCart(variantId, quantity = 1) {
            try {
                const formData = new FormData();
                formData.append('id', variantId);
                formData.append('quantity', quantity);

                const response = await fetch('/cart/add.js', {
                  method: 'POST',
                  body: formData
                });

                const data = await response.json();

                await this.CartManager.refreshCartView();
                this.CartManager.removePromotedProduct(data.product_id);
                this.CartManager.hidePromotedProducts();
            } catch (error) {
                console.error('Error adding product to cart:', error);
            }
        }
    }

    window.theme.ProductManager = ProductManager;
})();

